import { POST_SETTINGS_SUCCESS, POST_SETTINGS_FAIL, GET_SETTINGS_SUCCESS, GET_SETTINGS_FAIL, SETTINGS_PANEL, CLOSE_PANEL, SOUND_SETTINGS_PANEL, SET_INPUT_DEVICE, SET_OUTPUT_DEVICE, SETTINGS_MENU_OPEN, MODAL_STATE } from '../constants/buddyBooks';
import { GAME_URL } from '../constants';
import axios from 'axios';

window.getSettingsCalled = false;

export const getSettings = () => {
    window.getSettingsCalled = true;
    let savedUser = localStorage.getItem("logged_user");
    const person = savedUser && JSON.parse(savedUser);
    let studentId = person?.info?.personId;
    return async (dispatch, getState) => {
        const state = getState();
        let url = `${GAME_URL}/buddy-books/settings?studentId=${studentId}`;
        const config = {
            url,
            headers: {
                'access-token': `${state.platform.auth.token}`
            }
        }
        try {
            var res = await axios(config);
            console.log("getSettings success res", res.data);
            dispatch({
                type: GET_SETTINGS_SUCCESS,
                payload: res.data
            })
        } catch (err) {
            console.log("getSettings fail");
            dispatch({
                type: GET_SETTINGS_FAIL,
            })
        }
    }
}

export const postSettings = (settings) => {
    let savedUser = localStorage.getItem("logged_user");
    const person = savedUser && JSON.parse(savedUser);
    let studentId = person?.info?.personId;
    console.log("postSettings settings ", settings);
    return async (dispatch, getState) => {
        const state = getState();
        let url = `${GAME_URL}/buddy-books/settings?studentId=${studentId}`;
        let data = settings;
        let config = {
            method: "POST",
            url,
            data,
            headers: {
                "access-token": `${state.platform.auth.token}`
            }
        }
        try {
            await axios(config);
            console.log("postSettings success");
            dispatch({
                type: POST_SETTINGS_SUCCESS,
            })
        } catch (err) {
            console.log("postSettings fail");
            dispatch({
                type: POST_SETTINGS_FAIL
            })
        }
    }
}

export const settingsPanel = (bool) => {
    return {
        type: SETTINGS_PANEL,
        payload: bool
    }
}


export const panelClosing = (data) => {
    return {
        type: CLOSE_PANEL,
        settingsPanel: data.settingsPanel,
        searchPanel: data.searchPanel,
    }
}

export const soundSettings = (bool) => {
    return {
        type: SOUND_SETTINGS_PANEL,
        payload: bool
    }
}

export const setInputDevice = (data) => {
    return {
        type: SET_INPUT_DEVICE,
        payload: data
    }
}

export const setOutputDevice = (data) => {
    return {
        type: SET_OUTPUT_DEVICE,
        payload: data
    }
}

export const handleSettingsMenuState = (isSettingsMenuOpen) => {
    return ({
        type: SETTINGS_MENU_OPEN,
        isSettingsMenuOpen,
    })
}

export const modalState = ({isModalOpen, isQuestionClicked}) => {
    return ({
        type: MODAL_STATE,
        isModalOpen,
        isQuestionClicked
    })
}